module.exports = __webpack_public_path__ + "img/no-locked.8b888664.svg";